import {EditProps} from "react-admin";
import {DefaultEdit} from "../components/DefaultEdit";
import {SiteForm} from "./SiteForm";

export const SiteEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component="div">
      <SiteForm  />
    </DefaultEdit>
  );
};
